/**
 * JourneyDefinitionContract (AJIP-16.02.005 · WS1)
 * ---------------------------------------------------------------------
 * The canonical Journey Definition Contract. Protected engineering
 * asset per Additional Founder Directive. Superset of the AJIP-16.02.003
 * base definition (which remains the 9-field engine-facing contract).
 */
const REQUIRED_FIELDS = Object.freeze([
  // ── Identity ─────────────────────────────────────────────────────
  'journeyId',
  'journeyVersion',
  'journeyName',
  'journeyDescription',
  // ── Classification ───────────────────────────────────────────────
  'journeyType',
  'journeyCategory',
  'journeyAudience',
  // ── State ────────────────────────────────────────────────────────
  'registrationStatus',
  'requiredFeatureFlags',
  'entryConditions',
  'eligibilityRules',
  'permissionRequirements',
  'initialState',
  'supportedStates',
  'transitionConfiguration',
  // ── Policy ───────────────────────────────────────────────────────
  'persistencePolicyRef',
  'retentionPolicyRef',
  // ── Presentation-neutral metadata ────────────────────────────────
  'priority',
  'tags',
  'canonReference',
  'owner',
  // ── Lifecycle ────────────────────────────────────────────────────
  'createdAt',
  'updatedAt',
  'deprecationStatus',
  'replacementJourneyId',
]);

const EXTENSIBLE_FIELDS = Object.freeze(['extensions']);
const MAX_DEFINITION_BYTES = 32 * 1024;

const REGISTRATION_STATUSES = Object.freeze(['pending', 'registered', 'rejected', 'withdrawn']);
const DEPRECATION_STATUSES = Object.freeze(['none', 'deprecated', 'retired']);

const FORBIDDEN_KEYS = Object.freeze([
  'password', 'token', 'apiKey', 'secret', 'credential',
  'cardNumber', 'cvv', 'privateKey', 'sessionId',
]);

export {
  REQUIRED_FIELDS, EXTENSIBLE_FIELDS, MAX_DEFINITION_BYTES,
  REGISTRATION_STATUSES, DEPRECATION_STATUSES, FORBIDDEN_KEYS,
};
